import * as React from 'react';
import { brandPrimaryHover } from '../../../../styles/colors';
import { SvgIcon } from '../SvgIcon';

interface IProps extends React.SVGProps<SVGSVGElement> {
	fillColor?: string;
}

export const SocialMediaIndicatorIcon: React.FC<IProps> = ({
	className = '',
	fillColor,
	width = 25,
	height = 25,
	...props
}) => {
	return (
		<SvgIcon
			width={width}
			height={height}
			fill='none'
			className={`social-media-indicator-icon ${className}`}
			viewBox='0 0 25 25'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M24.8589 24.7751V7.29395C24.8589 3.42795 21.7249 0.293945 17.8589 0.293945H0.669922L24.8589 24.7751Z'
				fill={fillColor || brandPrimaryHover}
			/>
		</SvgIcon>
	);
};
